export const state = {
  stickyHeader: {
    id: null,
    height: 0
  }
}

export const getters = {}

export const actions = {}

export const mutations = {
  SET_STICKY_HEADER(state, stickyHeader) {
    // only attach sticky header if id is null or id is equal
    if (!state.stickyHeader.id || state.stickyHeader.id == stickyHeader.id) {
      state.stickyHeader.id = stickyHeader.id
      state.stickyHeader.height = stickyHeader.height
    }
  }
}
